import styled from 'styled-components';

export const StyledWrapper = styled.div.attrs((prop) => {})`
  display: flex;
  width: 90%;

  ${(props) => props.flexColumn && 'flex-direction: column'};
`;
